import { render } from "./GroupPermission.vue?vue&type=template&id=23e2e952"
import script from "./GroupPermission.vue?vue&type=script&lang=js"
export * from "./GroupPermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__